export default "__VITE_ASSET__D0w9uwYg__"